<template>
    <Breadcrumbs main="Ui Kits" title="Progress" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <basicProgressbar />
                <stripedProgressbar />
                <div class="row">
                    <multipleBars />
                </div>
                <customProgressbars />
                <smallProgressbars />
                <heightProgressbars />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const basicProgressbar = defineAsyncComponent(() => import("@/components/theme/uikits/progress/basicProgressbar.vue"))
const stripedProgressbar = defineAsyncComponent(() => import("@/components/theme/uikits/progress/stripedProgressbar.vue"))
const multipleBars = defineAsyncComponent(() => import("@/components/theme/uikits/progress/multipleBars.vue"))
const customProgressbars = defineAsyncComponent(() => import("@/components/theme/uikits/progress/customProgressbars.vue"))
const smallProgressbars = defineAsyncComponent(() => import("@/components/theme/uikits/progress/smallProgressbars.vue"))
const heightProgressbars = defineAsyncComponent(() => import("@/components/theme/uikits/progress/heightProgressbars.vue"))
</script>